import { jsx as m } from "react/jsx-runtime";
import { tv as n } from "tailwind-variants";
const o = n({
  base: [
    "aspect-square",
    "bg-rose-600",
    "flex",
    "font-bold",
    "font-secondary",
    "items-center",
    "justify-center",
    "leading-none",
    "rounded-full",
    "text-white",
    "text-sm",
    "w-[1.5rem]"
  ],
  variants: {
    size: {
      xs: ["w-[1.25rem]"],
      sm: ["w-[2.5rem]"],
      md: ["w-[4rem]"]
    }
  }
}), l = ({ ariaHidden: e, className: s, children: t, size: r = "md", title: a }) => /* @__PURE__ */ m(
  "div",
  {
    "aria-hidden": e,
    className: o({ class: s, size: r }),
    title: a,
    children: t
  }
);
export {
  l as default
};
